import { createContext, useContext, useMemo, useState, type ReactNode } from 'react';

type MainContextValue = {
  isHelpDrawerOpen: boolean;
  setIsHelpDrawerOpen: (isOpen: boolean) => void;
  journeyId?: string;
};

const MainContext = createContext<MainContextValue | undefined>(undefined);

export function MainProvider({ children, journeyId }: { children: ReactNode; journeyId?: string }) {
  const [isHelpDrawerOpen, setIsHelpDrawerOpen] = useState(false);

  const value = useMemo<MainContextValue>(
    () => ({
      isHelpDrawerOpen,
      setIsHelpDrawerOpen,
      journeyId,
    }),
    [isHelpDrawerOpen, setIsHelpDrawerOpen, journeyId]
  );

  return <MainContext.Provider value={value}>{children}</MainContext.Provider>;
}

export function useMainContext(): MainContextValue {
  const context = useContext(MainContext);

  if (!context) {
    throw new Error('useMainContext must be used within a MainProvider');
  }

  return context;
}
